const prepareDate = date => {
  return {
    month: date.getMonth() + 1,
    year: date.getFullYear(),
    day: date.getDate(),
    names: {
      month: {
        short: monthName(date.getMonth(), true),
        long: monthName(date.getMonth(), false)
      },
      day: {
        short: dayName(date.getDay(), true),
        long: dayName(date.getDay(), false)
      },
      time: {
        short: getTime(date)
      },
      date: {
        short: `${date.getMonth() + 1}/`
      }
    },
    weekdays: getWeekDayDates(
      new Date(date.getFullYear(), date.getMonth(), date.getDate())
    ),
    hour: date.getHours(),
    minute: date.getMinutes(),
    isToday: isToday(date)
  };
};

/*
  in the format returned by prepare date
*/
const toDate = date => {
  return new Date(date.year, date.month - 1, date.day, date.hour, date.minute);
};

const getWeekDayDates = date => {
  const weekdays = [];
  date.setDate(date.getDate() - date.getDay());

  for (let i = 0; i < 7; i++) {
    weekdays.push({
      day: {
        index: date.getDate(),
        name: dayName(date.getDay(), true),
        letter: dayLetter(i),
        month: monthName(date.getMonth(), true)
      },
      date: Object.assign({}, date),
      isToday: isToday(date)
    });
    date.setDate(date.getDate() + 1);
  }
  return weekdays;
};

/*
  Param: date, assumed to be in the structure that prepareDate() returns
  option can be day, month, week
*/
const isEventOn = (event, day, option = 'day') => {
  const date = toDate(day); // The selected date in the calendar
  const eventDate = new Date(event.start.date);
  if (option === 'day') {
    return (
      eventDate.getMonth() === date.getMonth() &&
      eventDate.getFullYear() === date.getFullYear() &&
      eventDate.getDate() === date.getDate()
    );
  } else if (option === 'month') {
    return (
      eventDate.getMonth() === date.getMonth() &&
      eventDate.getFullYear() === date.getFullYear()
    );
  } else {
    const weekStartsOn = toDate(day);
    weekStartsOn.setDate(weekStartsOn.getDate() - weekStartsOn.getDay());

    const weekEndsOn = toDate(day);
    weekEndsOn.setDate(weekEndsOn.getDate() - weekEndsOn.getDay() + 6);

    return eventDate >= weekStartsOn && eventDate <= weekEndsOn;
  }
};

/*
  Param: date, assumed to be in the structure that prepareDate() returns
*/
const lastMonth = date => {
  const dateObj = toDate(date);
  dateObj.setMonth(date.month === 1 ? 11 : date.month - 2);
  if (date.month === 1) {
    dateObj.setYear(date.year - 1);
  }
  return prepareDate(dateObj);
};

const nextMonth = date => {
  const dateObj = toDate(date);
  dateObj.setMonth(date.month === 11 ? 0 : date.month);
  if (date.month === 11) {
    dateObj.setYear(date.year + 1);
  }
  return prepareDate(dateObj);
};

const tomorrow = date => {
  const dateObj = toDate(date);
  dateObj.setDate(dateObj.getDate() + 1);
  return prepareDate(dateObj);
};

const yesterday = date => {
  const dateObj = toDate(date);
  dateObj.setDate(dateObj.getDate() - 1);
  return prepareDate(dateObj);
};

const lastWeek = date => {
  const dateObj = toDate(date);
  dateObj.setDate(dateObj.getDate() - 7);
  return prepareDate(dateObj);
};

const nextWeek = date => {
  const dateObj = toDate(date);
  dateObj.setDate(dateObj.getDate() + 7);
  return prepareDate(dateObj);
};

const daysInMonth = (month, year) => {
  return new Date(year, month, 0).getDate();
};

const isToday = date => {
  return (
    date.getDate() === new Date().getDate() &&
    date.getMonth() === new Date().getMonth()
  );
};

const getTime = date => {
  let mins = date.getMinutes();
  if (mins.toString().length === 1) {
    mins += '0';
  }
  let hours = date.getHours();
  if (hours > 12) {
    hours = hours - 12;
  }
  if (hours.toString().length === 1) {
    hours = `${hours}`;
  }
  if (date.getHours() >= 12) {
    return `${hours}:${mins} PM`;
  }

  return `${hours}:${mins} AM`;
};
const dayName = (day, short = false) => {
  switch (day) {
    case 0:
      return short ? 'Sun' : 'Sunday';
    case 1:
      return short ? 'Mon' : 'Monday';
    case 2:
      return short ? 'Tue' : 'Tuesday';
    case 3:
      return short ? 'Wed' : 'Wednesday';
    case 4:
      return short ? 'Thur' : 'Thursday';
    case 5:
      return short ? 'Fri' : 'Friday';
    default:
      return short ? 'Sat' : 'Saturday';
  }
};

const dayLetter = day => {
  switch (day) {
    case 0:
      return 'S';
    case 1:
      return 'M';
    case 2:
      return 'T';
    case 3:
      return 'W';
    case 4:
      return 'T';
    case 5:
      return 'F';
    default:
      return 'S';
  }
};

const monthName = (month, short = false) => {
  switch (month) {
    case 0:
      return short ? 'Jan' : 'January';
    case 1:
      return short ? 'Feb' : 'February';
    case 2:
      return short ? 'Mar' : 'March';
    case 3:
      return short ? 'Apr' : 'April';
    case 4:
      return short ? 'May' : 'May';
    case 5:
      return short ? 'Jun' : 'June';
    case 6:
      return short ? 'Jul' : 'July';
    case 7:
      return short ? 'Aug' : 'August';
    case 8:
      return short ? 'Sept' : 'September';
    case 9:
      return short ? 'Oct' : 'October';
    case 10:
      return short ? 'Nov' : 'November';
    default:
      return short ? 'Dec' : 'December';
  }
};

const getWorkingHours = () => {
  const times = [];
  let amOrPm = 'AM';
  // 8am to 7pm
  for (let i = 0; i < 24; i++) {
    if (i >= 12) {
      amOrPm = 'PM';
    }
    for (let x = 0; x < 60; x += 15) {
      let minutes = x === 0 ? `00` : x.toString();
      let hour = i;
      if (i > 12) {
        hour = i - 12;
      }
      if (hour.toString().length === 1) {
        //hour = `0${hour.toString()}`;
      }

      times.push({
        display: `${hour}:${minutes} ${amOrPm}`,
        hour: i,
        minute: x,
        am: true
      });
    }
  }

  return times;
};

const formatDate = (date, style = 'yyyy-mm-dd') => {
  let day = date.getDate();
  const year = date.getFullYear().toString();
  let month = date.getMonth() + 1;
  if (month.toString().length === 1) {
    month = `0${month}`;
  }
  if (day.toString().length === 1) {
    day = `0${day}`;
  }
  if (style === 'yyyy-mm-dd') {
    return `${year}-${month}-${day}`;
  } else if (style === 'dd/mm/yyyy') {
    return `${day}/${month}/${year}`;
  } else {
    return `${dayName(date.getDay(), true)} ${day} ${monthName(
      date.getMonth(),
      true
    )} ${year}`;
  }
};

const getCalendarDays = (month, year, day = -1, minMonth, maxMonth) => {
  const monthStart = new Date(year, month - 1, 1);
  const dayStart = monthStart.getDay(); // 0 == Sun
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Reset time for comparison

  let previousDayCount = 0;
  switch (dayStart) {
    case 1:
      previousDayCount = 0;
      break;
    case 2:
      previousDayCount = 1;
      break;
    case 3:
      previousDayCount = 2;
      break;
    case 4:
      previousDayCount = 3;
      break;
    case 5:
      previousDayCount = 4;
      break;
    case 6:
      previousDayCount = 5;
      break;
    default:
      // 0 Sunday
      previousDayCount = 6;
      break;
  }

  let days = [];
  const calendarStartDays = [];
  const calendarStart = new Date(year, month - 1, 1);

  for (let i = previousDayCount; i > 0; i--) {
    calendarStart.setDate(calendarStart.getDate() - 1);
    calendarStartDays.push({
      date: formatDate(calendarStart),
      obj: prepareDate(calendarStart)
    });
  }

  days = [...calendarStartDays.reverse()];

  for (let i = 0; i < daysInMonth(month, year); i++) {
    days.push({
      date: formatDate(monthStart),
      isCurrentMonth: true,
      isToday: isToday(monthStart),
      isSelected: day === monthStart.getDate() || isToday(monthStart),
      obj: prepareDate(monthStart),
      isInPast: monthStart < today
    });
    monthStart.setDate(monthStart.getDate() + 1);
  }

  for (let i = days.length; i < 42; i++) {
    days.push({
      date: formatDate(monthStart),
      isCurrentMonth: false,
      obj: prepareDate(monthStart),
      isInPast: monthStart < today
    });
    monthStart.setDate(monthStart.getDate() + 1);
  }

  if (minMonth) {
    days = days.map(d => {
      if (!d.isCurrentMonth && d.obj.month < minMonth) {
        return {
          ...d,
          hidden: true
        };
      }
      return d;
    });
  }

  if (maxMonth) {
    days = days.map(d => {
      if (!d.isCurrentMonth && d.obj.month > maxMonth) {
        return {
          ...d,
          hidden: true
        };
      }
      return d;
    });
  }

  return days;
};

const CALENDAR_VIEW = {
  DAY: 'DAY',
  MONTH: 'MONTH',
  WEEK: 'WEEK'
};

export {
  CALENDAR_VIEW,
  lastWeek,
  nextWeek,
  tomorrow,
  yesterday,
  lastMonth,
  nextMonth,
  prepareDate,
  daysInMonth,
  isToday,
  dayName,
  dayLetter,
  monthName,
  formatDate,
  getCalendarDays,
  getTime,
  isEventOn,
  getWorkingHours,
  toDate
};
